import { html } from 'lit-element'

import "./legal-dialog.scss"

import LitElementBase from './element-base'
import showdown from "showdown"
import { Modal as BootstrapModal } from "bootstrap"

export default class LegalDialog extends LitElementBase {

    static get DomTag() { return 'gdpr-legal-dialog'; }

    static get LANGS() {
        return {
            "it": "it",
            "en": "en"
        }
    }

    static get properties() {
        return {
            body: { type: String },
            title_label: { type: String },
            urls: { type: String },
            is_markdown: { type: Boolean }
        };
    }

    GetTranslations() {
        return {
            "Close": {
                "it": "Chiudi",
                "en": "Close"
            },
            "Loading": {
                "it": "Caricamento…",
                "en": "Loading…"
            },
            "Error": {
                "it": "Si è verificato un errore durante il caricamento del contenuto",
                "en": "An error has occurred while loading the content"
            },
            "Terms and Conditions": {
                "it": "Termini e Condizioni",
                "en": "Terms and Conditions"
            },
            "Privacy": {
                "it": "Privacy",
                "en": "Privacy"
            },
            "Cookies": {
                "it": "Cookies",
                "en": "Cookies"
            }
        }
    }

    render() {
        return html`
			<div class="Modal modal" tabindex="-1" data-bs-backdrop="static">
				<div class="modal-dialog modal-dialog-scrollable modal-lg">
					<div class="modal-content ${!this.is_markdown ? "has-iframe" : ""}">
						<div class="modal-header">
                            <h5 class="modal-title">${this.title_label}</h5>
							<button type="button" class="btn-close" @click="${() => { this.CloseDialog() }}" aria-label="Close"></button>
						</div>
						<div class="modal-body">
							${this.body}
						</div>
                        ${!this.is_markdown ? html`
                            <iframe src="${this.urls}" @load="${() => { this.querySelector(".modal-body").remove() }}"></iframe>
                        ` : null}
						<div class="modal-footer">
							<button @click="${() => { this.CloseDialog() }}" type="button" class="btn btn-primary">${this.Ln("Close")}</button>
						</div>
					</div>
				</div>
			</div>`;
    }

    GetContent() {
        this.body = this.Ln("Loading");

        if (this.is_markdown) {
            Promise.all(
                this.urls.split(",").map(
                    url => fetch(url)
                        .then(res => res.text())
                )
            )
                .then((res) => {
                    let print = "";
                    res.forEach(text => {
                        print += text;
                    })
                    var converter = new showdown.Converter({ tables: true });
                    this.body = this.ToHtml(converter.makeHtml(print));
                })
                .catch(() => {
                    this.body = this.Ln("Error");
                });
        }
    }

    firstUpdated() {
        super.firstUpdated()

        const modalEl = this.querySelector('.Modal')
        this.modal = new BootstrapModal(modalEl)
        this.modal.show()
        modalEl.addEventListener("hidden.bs.modal", () => {
            this.remove()
        })

        this.GetContent()
    }

    static ShowTerms(oPolicy) {
        let elDlg = new LegalDialog();
        let lang = elDlg.lang;

        if (!LegalDialog.LANGS[lang])
            lang = "it"

        elDlg.title_label = elDlg.Ln("Terms and Conditions");

        if (oPolicy.url) {
            elDlg.urls = oPolicy.url;
            elDlg.is_markdown = oPolicy.isMarkdown;
        } else
            throw "No supplied terms URL"

        document.body.append(elDlg)
    }

    static ShowPrivacy(oPolicy) {
        let elDlg = new LegalDialog();
        let lang = elDlg.lang;

        if (!LegalDialog.LANGS[lang])
            lang = "it"

        elDlg.title_label = elDlg.Ln("Privacy");

        if (oPolicy.url) {
            elDlg.urls = oPolicy.url;
            elDlg.is_markdown = oPolicy.isMarkdown;
        } else
            throw "No supplied privacy policy URL"

        document.body.append(elDlg)
    }

    static ShowCookies(oPolicy) {
        let elDlg = new LegalDialog();
        let lang = elDlg.lang;

        if (!LegalDialog.LANGS[lang])
            lang = "it"

        elDlg.title_label = elDlg.Ln("Cookies");

        if (oPolicy.url) {
            elDlg.urls = oPolicy.url;
            elDlg.is_markdown = oPolicy.isMarkdown;
        } else
            throw "No supplied cookie policy URL"

        document.body.append(elDlg)
    }

    CloseDialog() {
        this.modal.hide()
    }
}

LegalDialog.RegisterElement()